import type { DataSource, UiError } from '../contract.js';
import { prefersReducedMotion } from '../stage/motion.js';
import { resetPointer } from '../state/gesture.js';
import { popLateDay } from '../state/nav.js';
import { stopTick } from '../state/playback.js';
import { AppStore } from '../state/store.js';

/** Build the app store and connect the hooks that live in other modules. */
export function createAppStore(data: DataSource, options: { readonly reduced?: () => boolean; readonly log?: (error: UiError) => void } = {}): AppStore {
  const store = new AppStore({ data, reduced: options.reduced ?? prefersReducedMotion, ...(options.log ? { log: options.log } : {}) });
  store.onDayLoaded = (date) => popLateDay(store, date);
  store.stopPlayback = () => stopTick(store);
  store.resetPointer = () => resetPointer(store);
  return store;
}
